// keyrd_console/src/components/SidebarNav.js
import React from "react";

const sidebarStyle = {
  width: 240,
  backgroundColor: "#0b3d2e",
  color: "#d1fae5",
  display: "flex",
  flexDirection: "column",
  padding: "16px 12px",
};

const headerStyle = {
  fontWeight: 600,
  fontSize: 16,
  margin: "0 8px 12px",
};

const sectionLabelStyle = {
  fontSize: 11,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  margin: "16px 8px 4px",
  color: "#6ee7b7",
};

const itemStyle = (active) => ({
  padding: "8px 10px",
  borderRadius: 8,
  margin: "2px 4px",
  fontSize: 14,
  cursor: "pointer",
  backgroundColor: active ? "#064e3b" : "transparent",
  color: active ? "#ecfdf5" : "#d1fae5",
  border: "none",
  textAlign: "left",
  width: "100%",
});

const NAV_SECTIONS = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { id: "dashboard", label: "Dashboard" },
      { id: "alerts", label: "Alerts" },
    ],
  },
  {
    id: "patients",
    label: "Patients",
    items: [
      { id: "patients", label: "Patient List" },
      { id: "patientProfile", label: "Patient Profile" },
      { id: "nudgePlan", label: "Nudge Plan Builder" },
      { id: "history", label: "Behavior History" },
    ],
  },
  {
    id: "pilotOperations",
    label: "Pilot Operations",
    items: [
      { id: "pilotOverview", label: "Pilot Overview" },
      { id: "pilotParticipants", label: "Participants" },
      { id: "pilotPreflight", label: "Preflight" },
      { id: "pilotShadow", label: "Shadow State" },
      { id: "pilotAlerts", label: "Pilot Alerts" },
      { id: "pilotSystem", label: "Governance" },
      { id: "pilotAudit", label: "Audit Trail" },
      { id: "pilotQueue", label: "Operations Queue" },
      { id: "pilotInvites", label: "Invites / Cohorts" },
    ],
  },
  {
    id: "safety_dev",
    label: "Safety & Dev",
    items: [
      { id: "riskSafety", label: "Risk & Safety" },
      { id: "devLogs", label: "Developer Logs" },
    ],
  },
];

function SidebarNav({ activeTab, onTabChange }) {
  const handleClick = (id) => {
    if (typeof onTabChange === "function") {
      onTabChange(id);
    }
  };

  return (
    <aside style={sidebarStyle}>
      <div style={headerStyle}>RDN Console</div>

      {NAV_SECTIONS.map((section) => (
        <div key={section.id}>
          <div style={sectionLabelStyle}>{section.label}</div>
          {section.items.map((item) => (
            <button
              key={item.id}
              style={itemStyle(activeTab === item.id)}
              onClick={() => handleClick(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
      ))}
    </aside>
  );
}

export default SidebarNav;